<template>
    <div class="row">
        <div class="col-12">
            <card card-body-classes="table-full" no-footer-line>
                <div slot="header" class="split-header">
                    <h4 class="card-title">
                        {{ `Manage Registrations ${isAdmin ? `for ${title}` : ''}` }}
                    </h4>
                    <el-select 
                        v-if="isAdmin && programme" 
                        class="select-primary"
                        v-model="titleSlug" 
                        placeholder="Select an Event" 
                        @change="handleViewRegistrationsEvent">
                        <el-option
                            class="select-primary"
                            v-for="event in programme.events"
                            :key="event.slug"
                            :label="event.title"
                            :value="event.slug" />
                    </el-select>
                </div>

                <template v-if="isAdmin">
                    <div>
                        <div class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                            <div>
                                
                                <el-select
                                    class="select-primary mb-3"
                                    style="width: 200px"
                                    v-model="pagination.perPage"
                                    v-if="pagination"
                                    placeholder="Per page"
                                >
                                    <el-option class="select-primary" v-for="item in pagination.perPageOptions"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                    ></el-option>
                                </el-select>

                                <!-- <n-button
                                    @click.native="createProgramme()"
                                    class="view ml-2"
                                    type="primary"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-plus"></i>
                                </n-button> -->

                                <!-- <n-button
                                    @click.native="openUploadModal()"
                                    class="view ml-2"
                                    type="warning"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-upload"></i>
                                </n-button> -->

                                <vue-json-to-csv :json-data="formattedData"
                                    :labels="csvTitles"
                                    :csv-title="`${title}-report`"
                                    v-if="isAdmin"
                                    >
                                    <el-tooltip class="item" effect="dark" content="Download CSV Report" placement="right">
                                    <n-button class="download" type="success" size="sm" round icon simple style="margin-left: 10px">
                                        <i class="fa fa-download"></i>
                                    </n-button>
                                    </el-tooltip>
                                </vue-json-to-csv>
                                <!-- <JsonCSV :data="tableData">
                                    <el-tooltip class="item" effect="dark" content="Download CSV Report" placement="right">
                                        <n-button class="download" type="success" size="sm" round icon simple >
                                            <i class="fa fa-download"></i>
                                        </n-button>
                                    </el-tooltip>
                                </JsonCSV> -->

                            </div>
                            
                            <fg-input>
                                <el-input type="search"  class="mb-3" style="width: 400px"
                                prefix-icon="el-icon-search"
                                :placeholder="`Search by ${propsToSearch.join(', ').trim(', ').replace('.', ' ')}`"
                                v-model="searchQuery"
                                aria-controls="datatables"
                                ></el-input>
                            </fg-input>
                        </div>
                        <el-table stripe style="width: 100%;" :data="queriedData" size="mini">
                            <template v-for="(column, index) in tableColumns">
                            <el-table-column
                                v-if="!column.hidden"
                                :key="index"
                                :min-width="column.minWidth"
                                :prop="column.prop"
                                :label="column.label"
                                :sortable="column.sortable || false"
                                :align="column.align"
                                :header-align="column.align"
                                :fixed="column.fixed || false"
                                :formatter="column.formatter || null"
                                :sort-by="column.prop"
                            ></el-table-column>
                            </template>
                            
                            <el-table-column :min-width="135" fixed="right" label="Actions" align="right">
                                <div slot-scope="props" class="table-actions">
                                    <!-- <n-button
                                        @click.native="handleView(props.$index, props.row)"
                                        class="view"
                                        type="primary"
                                        size="sm"
                                        round
                                        icon
                                        simple
                                    >
                                        <i class="fa fa-eye"></i>
                                    </n-button>
                                    <n-button
                                        @click.native="handleEdit(props.$index, props.row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        round
                                        icon
                                        simple
                                    >
                                        <i class="fa fa-pencil"></i>
                                    </n-button> -->
                                    <el-tooltip class="item" effect="dark" content="Delete" placement="top">
                                        <n-button @click.native="handleDelete(props.$index, props.row)" class="remove" type="danger" size="sm" round icon simple :disabled="props.row.deleted || (props.row.programme.price > 0 && !props.row.paid)">
                                            <i class="fa fa-times"></i>
                                        </n-button>
                                    </el-tooltip>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class="d-flex justify-content-center justify-content-sm-between flex-wrap"
                    >
                        <div class>
                        <p class="card-category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
                        </div>
                        <n-pagination
                        class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="total"
                        ></n-pagination>
                    </div>
                </template>
            </card>

            <div class="row" v-if="!isAdmin">
                <template v-if="tableData.length > 0">
                <div class="col-4 mr-auto" v-for="(ticket, index) in tableData" :key="index">
                    <TicketCard v-bind="ticket" @card-click="deleteRegistration"/>
                </div>
                </template>
                <div v-else>
                    <p>Sorry, no registration details are available at the moment.</p>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import { Table, TableColumn, Select, Option, Upload, Progress } from "element-ui";
import { Pagination as NPagination, TicketCard } from "src/components";
import Fuse from "fuse.js";
import swal from "sweetalert2";
import VueJsonToCsv from 'vue-json-to-csv'
import JsonCSV from 'vue-json-csv'

import { mapGetters } from 'vuex';

export default {
    components: {
        NPagination,
        VueJsonToCsv,
        JsonCSV,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Upload.name]: Upload,
        [Progress.name]: Progress,
        TicketCard
    },
    computed: {
        ...mapGetters({
            tableData: 'getRegistrations',
            authTokens: 'getAuthTokens',
            preferences: 'getPreferences',
            programme: 'getProgramme'
        }),

        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.searchedData;
            // if (this.searchedData.length > 0) {
            //     result = this.searchedData;
            // }
            result = result.map(item => {
                if(this.entity == 'event'){
                    item.events_title = item.events.find(ev => ev.slug == this.$route.params.slug).title
                } 
                else{
                    item.events_title = item.events.map((ev) => ev.title).join(', ').trim(', ')
                }
                return item
            })
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0 ? this.searchedData.length : this.tableData.length;
        },
        title() {
            if(this.entity === 'programme'){
                if(this.tableData.length > 0){
                    return this.tableData[this.tableData.length - 1].programme.title
                }
            }
            if(this.entity === 'event'){
                if(this.tableData.length > 0){
                    return this.tableData[this.tableData.length - 1].events.find(ev => ev.slug === this.$route.params.slug).title
                }
            }
            return ''
        },
        titleSlug: {
            get(){
                return this.entity == 'event' ? this.$route.params.slug : null
            },
            set(){
                // nothing
            }
        },
        formattedData(){
            return this.tableData.map(item => {
                let el = JSON.parse(JSON.stringify(item))
                el.reg_id = el.reg_id.toUpperCase();
                el.register_no = el.email ? el.email.split('@')[0] : '--';
                el.price = el.events.reduce(function(sum, ob){ return sum + parseFloat(ob.price)}, 0);
                el.programme = el.programme.title;

                // change from UTC to Local DateTime 
                el.updated_at = new Date(el.updated_at).toLocaleString();
                el.created_at = new Date(el.created_at).toLocaleString();
                
                if(this.entity == 'event'){
                    el.events = item.events.find(ev => ev.slug == this.$route.params.slug).title
                }
                if(this.entity == 'programme'){
                    el.events = item.events.map((ob) => ob.title).join(', ').trim(', ');
                }

                // parse form data to outermost layer
                if(this.isAdmin){
                    let form = []
                    
                    if(this.entity == 'event'){
                        // let evt = item.events.find(ev => ev.slug == this.$route.params.slug)
                        form = item.events.find(ev => ev.slug == this.$route.params.slug).form
                        // console.log("🚀 ~ file: List.vue ~ line 284 ~ formattedData ~ form", form)
                        form.forEach(input => {
                            // console.log("🚀 ~ file: List.vue ~ line 286 ~ formattedData ~ input", input[0])
                            // console.log('here 1');
                            if('participants_pool' in item && item.participants_pool.length > 0){
                                // console.log('here 2');
                                if(input[0].value){
                                    // console.log('here 3');
                                    let ans = item.participants_pool.find(part => part.email == input[0].value)
                                    if(ans)
                                        el[`f0rm_${input[0].name.replaceAll('-','_')}`] = `${ans.name}, ${ans.phone}, ${ans.email}`
                                    else
                                        el[`f0rm_${input[0].name.replaceAll('-','_')}`] = input[0].value
                                    // console.log('here 4');
                                }
                            }
                            else{
                                // console.log('here 5');
                                el[`f0rm_${input[0].name.replaceAll('-','_')}`] = input[0].value
                                // console.log('here 6');
                            }
                        })
                    }

                    if(this.entity == 'programme'){
                        form = item.programme.form
                        form.forEach(input => {
                            el[`f0rm_${input.name.replaceAll('-','_')}`] = input.value
                        })
                        // add particiapnts pool
                        if('participants_pool' in item && item.participants_pool.length > 0)
                            el.participants = item.participants_pool.reduce((acc, part) => `${part.name}, ${part.phone}, ${part.email} | ${acc}`, "").trim("|")
                        else
                            el.particiapnts = "NA"
                    }
                }

                return el
            })
        },
        isAdmin(){
            return (this.$currentUser) ? this.$currentUser.roles.includes('admin') : false
        },
        csvTitles(){
            return {...this.titles, ...this.form_titles}
        }
    },
    data() {
        return {
            entity: 'programme',
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 25, 50, 100],
                total: 0
            },
            searchQuery: "",
            propsToSearch: [ "reg_id", "email", "programme.title" ],
            tableColumns: [
                {
                    prop: "reg_id",
                    label: "Reg ID",
                    minWidth: 160,
                    formatter: function(row, column, cellValue, index){
                        return cellValue.toUpperCase();
                    }
                },
                {
                    prop: "email",
                    label: "Email ID",
                    minWidth: 240,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "programme.title",
                    label: "Programme",
                    minWidth: 240,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "events_title",
                    label: "Event(s)",
                    minWidth: 240,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "paid",
                    label: "Paid ?",
                    minWidth: 120,
                    align: 'center',
                    sortable: false,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        return (cellValue) ? 'Yes' : 'No'; 
                    }
                },
                {
                    prop: "attendance",
                    label: "Attended ?",
                    minWidth: 140,
                    align: 'center',
                    sortable: false,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        return (cellValue) ? 'Yes' : 'No'; 
                    }
                },
                {
                    prop: "deleted",
                    label: "Deleted ?",
                    minWidth: 120,
                    align: 'center',
                    sortable: false,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        return (cellValue) ? 'Yes' : 'No'; 
                    }
                },
                {
                    prop: "created_at",
                    label: "Created",
                    minWidth: 200,
                    align: 'right',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        var d = cellValue ? new Date(cellValue) : new Date();
                        var options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }
                        return  d.toLocaleDateString('en-US', options); 
                    }
                },
                {
                    prop: "updated_at",
                    label: "Updated",
                    minWidth: 200,
                    align: 'right',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        var d = cellValue ? new Date(cellValue) : new Date();
                        var options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }
                        return  d.toLocaleDateString('en-US', options); 
                    }
                }
                
            ],
            searchedData: [],
            fuseSearch: null,
            modals: {
                add: false,
                upload: false
            },
            titles: {
                reg_id : { title: "Reg ID" }, 
                txn_id : { title: "Transaction ID" }, 
                register_no : { title: "Register No" },
                name : { title: "Name" },
                mobile : { title: "Mobile" },
                email : { title: "Email" },
                programme: {title: 'Programme'},
                events: {title: 'Events'},
                price: {title: 'Price'},
                totalPrice: {title: 'Total Price'},
                additionalCharges: {title: 'Additional Charges'},
                paid: {title: 'Paid ?'},
                attendance : { title: "Attendend ?" },
                deleted: {title: 'Deleted ?'},
                created_at: {title: 'Created At'},
                updated_at: {title: 'Updated At'},
                participants: {title: 'Participants'}
            },
            form_titles: {},
            filterMethod(query, item) {
                return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
            }
        };
    },
    methods: {
        handleView(index, row) {
            // this.$router.push(`/programmes/view/${row.slug}`)
        },
        handleEdit(index, row) {
            // this.$router.push(`/programmes/edit/${row.slug}`)
        },
        handleDelete(index, row) {
            swal({
                title: "Are you sure?",
                text: `You won't be able to revert this!`,
                showCancelButton: true,
                confirmButtonClass: "btn btn-danger btn-fill",
                cancelButtonClass: "btn btn-default btn-fill",
                confirmButtonText: "Delete it!",
                buttonsStyling: false
            }).
            then(result => {
                if (result.value) {
                    this.deleteRow(row);
                }
            });
        },     
        deleteRow(row) {
            this.$store.dispatch('deleteRegistration', {
                reg_id: row.reg_id,
                slug: this.$route.params.slug,
                type: this.entity
            })
        },
        deleteRegistration(reg_id){
            swal({
                title: "Are you sure?",
                text: `You won't be able to revert this!`,
                showCancelButton: true,
                confirmButtonClass: "btn btn-danger btn-fill",
                cancelButtonClass: "btn btn-default btn-fill",
                confirmButtonText: "Delete it!",
                buttonsStyling: false
            }).
            then(result => {
                if (result.value) {
                    this.$store.dispatch('deleteRegistration', {
                        reg_id: reg_id,
                        slug: this.$route.params.slug,
                        type: this.entity
                    })
                }
            });
        },
        handleViewRegistrationsEvent(slug) {
            console.log("🚀 ~ file: List.vue ~ line 499 ~ handleViewRegistrationsEvent ~ slug", slug)
            this.$router.push(`/registrations/view/event/${slug}`)
            this.entity = 'event'
            this.$store.dispatch('getEventRegistrations', slug)
        },
    },
    mounted() {
        // // Fuse search initialization.
        // this.fuseSearch = new Fuse(this.tableData, {
        //     keys: this.propsToSearch,
        //     threshold: 0.1
        // });

        this.$nextTick(() => {
            this.pagination.perPage = this.preferences.perPage
        })

        if(this.$route.path.includes('view/programme')){
            this.entity = 'programme'
            this.$store.dispatch('getProgrammeRegistrations', this.$route.params.slug)
        }
        else if(this.$route.path.includes('view/event')){
            this.entity = 'event'
            this.$store.dispatch('getEventRegistrations', this.$route.params.slug)
        }
        else {
            this.$store.dispatch('getUserRegistrations')
        }
        
    },
    watch: {
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        searchQuery: {
            handler: function(value){
                let result = Object.assign([], this.tableData);
                if (value !== "") {
                    result = this.fuseSearch.search(value);
                }
                this.searchedData = result;
            },
            immediate: true
        },

        tableData: {
            handler: function(value){
                
                this.fuseSearch = new Fuse(value, {
                    keys: this.propsToSearch,
                    threshold: 0.1
                })
                let result = Object.assign([], value);
                
                if (this.searchQuery !== "") {
                    result = this.fuseSearch.search(this.searchQuery);
                }
                this.searchedData = result;

                // populate form titles
                // form from inside event or programme
                if(this.isAdmin){
                    let formData = []
                    if(this.tableData.length > 0){
                        // call store to get programme details
                        this.$store.dispatch('getProgramme', this.tableData[this.tableData.length - 1].programme.slug);

                        if(this.entity == 'event'){
                            // formData = this.tableData[this.tableData.length - 1].events[0].form
                            formData = this.tableData[this.tableData.length - 1].events.find(ev => ev.slug == this.$route.params.slug).form
                            // console.log('event-formData', formData);
                            // map the formfield name and its title
                            formData =formData.map(item => {
                                // console.log('item', typeof(item), item);
                                return {
                                    name: `f0rm_${item[0].name.replaceAll('-','_')}`,
                                    title: item[0].displayname
                                }
                            })
                        }
                        if(this.entity == 'programme'){
                            formData = this.tableData[this.tableData.length - 1].programme.form
                            // map the formfield name and its title
                            formData =formData.map(item => {
                                return {
                                    name: `f0rm_${item.name.replaceAll('-','_')}`,
                                    title: item.displayname
                                }
                            })
                        }
                        
                        // convert the array recived from map to an object
                        let formDataObject = {}
                        formData.forEach(item => {
                            formDataObject[item.name] = {title: item.title}
                        })

                        this.form_titles = formDataObject
                    }
                }
            },
            immediate: true
        },

        'pagination.perPage'(value){
            this.preferences.perPage = value
            this.$store.commit('setPreferences', this.preferences)
        }
    }
};
</script>
<style lang="scss">
    .has-success.has-label:after, 
    .has-danger.has-label:after {
        top: 43px;
    }

    .el-transfer-panel__filter.el-input{
        width: 85%;
    }

    .upload-file{
        text-align: center;
    }

    p.status{
        text-align: center;
        width: 100%;
        display: block;
    }

    .el-upload__tip em {
        color: #409EFF;
        font-style: normal;
        cursor: pointer;
    }
    .el-progress{
        width: 75%;
        margin: 10px auto;
    }

    .el-progress-bar{
        margin-right: -25px;
        padding-right: 25px;
    }

    .split-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-select{
            max-width: 400px;
        }
    }
</style>

